export default {
  paid: 'Pagado',
  pending: 'Pendiente',
  refund: 'Reembolsado',
  declined: 'Declinado',
};
